'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.devicecert.list', [])
  .controller('DeviceCertListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/devicecert/list/index.js